import {createAction, props} from '@ngrx/store';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';
import {LanguageEnum} from '@core/enums/language.enum';
import {LanguageStyleEnum} from '@core/enums/language-style.enum';
import {UnitARequestModel} from '@core/modules/rest/consent/request/unit-a-request.model';

export const GetConsentUseCases = createAction(
    '[ConsentUseCase] Get all consent use-cases',
    props<{ indicationId: string, language: LanguageEnum, languageStyle: LanguageStyleEnum }>()
);

export const GetConsentUseCasesSuccess = createAction(
    '[ConsentUseCase] Get all consent use-cases success',
    props<{ consentUseCases: ConsentUseCaseBasicModel[] }>()
);

export const SetConsentChapterDetails = createAction(
    '[ConsentUseCase] Set chapter use cases',
    props<{ chapterUseCases: UnitARequestModel[] }>()
);
